import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconTopTracks = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={37}
    height={33}
    fill="none"
    viewBox="0 0 37 33"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-top-tracks_svg__a)">
      <path
        fill="url(#icon-top-tracks_svg__b)"
        d="M27.75 14.25c.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25h-10c-.703 0-1.25-.547-1.25-1.25 0-.664.547-1.25 1.25-1.25h10Zm-10-3.75c-.703 0-1.25-.547-1.25-1.25 0-.664.547-1.25 1.25-1.25h10c.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25h-10Zm10 10c.664 0 1.25.586 1.25 1.25 0 .703-.586 1.25-1.25 1.25h-10c-.703 0-1.25-.547-1.25-1.25 0-.664.547-1.25 1.25-1.25h10Zm-17.188-6.25c-.546 0-.937-.39-.937-.938 0-.507.39-.937.938-.937h.624V9.328c-.43.156-.898-.039-1.132-.43-.274-.43-.117-1.015.312-1.289l1.25-.703c.313-.195.664-.195.938 0a.898.898 0 0 1 .508.782v4.687h.624c.508 0 .938.352.938.938 0 .546-.43.937-.938.937h-3.124Zm3.75 8.125c.508 0 .938.43.938.977 0 .507-.43.898-.938.898H9.899c-.351 0-.703-.234-.859-.586-.117-.352-.039-.781.274-1.016l3.242-2.93c.43-.35.468-.937.117-1.327a.768.768 0 0 0-.664-.352.864.864 0 0 0-.742.234l-.508.43a.974.974 0 0 1-1.328-.117.974.974 0 0 1 .117-1.328l.469-.43a2.804 2.804 0 0 1 2.109-.664 2.7 2.7 0 0 1 1.992 1.016 2.828 2.828 0 0 1-.312 3.945l-1.446 1.25h1.954Z"
      />
    </g>
    <defs>
      <linearGradient
        id="icon-top-tracks_svg__b"
        x1={29}
        x2={10.025}
        y1={6}
        y2={25.974}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
      <filter
        id="icon-top-tracks_svg__a"
        width={36.078}
        height={35}
        x={0.922}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6025_5361"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_6025_5361"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_6025_5361"
          result="effect2_dropShadow_6025_5361"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_6025_5361"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconTopTracks;
